import { format } from 'date-fns'
import koLocale from 'date-fns/locale/ko'
import { computed, makeObservable, observable } from 'mobx'

import { EMPTY_NUMBER_ID, EMPTY_STRING_ID } from '@/constant/common'

import { DTO } from '../DTO'

export class Qna extends DTO implements res.Inquire {
  id = EMPTY_NUMBER_ID
  teacherId = EMPTY_STRING_ID
  solved = false
  questionType: res.Inquire['questionType'] = 'CONTENT'
  questionDate = ''
  questionTitle = ''
  questionContent = ''
  replyContent: res.Inquire['replyContent'] = null
  replyDate: res.Inquire['replyDate'] = null

  constructor(data?: res.Inquire) {
    super()

    makeObservable(this, {
      id: observable,
      teacherId: observable,
      solved: observable,
      questionType: observable,
      questionDate: observable,
      questionTitle: observable,
      questionContent: observable,
      replyContent: observable,
      replyDate: observable,
      korTag: computed,
    })

    if (data) this.update<Qna>(data)
  }

  get korTag() {
    switch (this.questionType) {
      case 'CONTENT':
        return '문제은행'
      case 'FUNCTION_BUG':
        return '기능오류'
      case 'FUNCTION_INQUIRY':
        return '기능문의'
      case 'FAQ':
        return 'FAQ수정'
      case 'ETC':
        return '기타문의'
      case 'PRINTING_SETTLEMENT':
        return '매쓰플랫 프린팅 정산'
    }
  }

  get formattedReplyDate() {
    if (this.replyDate) {
      return format(new Date(this.replyDate), 'yyyy.MM.dd a hh:mm', { locale: koLocale })
    }
  }

  get formattedQuestionDate() {
    return format(new Date(this.questionDate), 'yyyy.MM.dd a hh:mm', { locale: koLocale })
  }
}
